import React, { Component } from "react"
import { Modal, Form, Button } from "react-bootstrap"
import { connect } from "react-redux"
import Select from "react-select"
import DatePicker from "react-datepicker"
import moment from "moment"
import { buildOptions } from "../utils"
import withFetchHook from "../withFetchHook"
import { sendStaffAppMetaData } from "../staffApp/eventTriggers"

class EducationFormModal extends Component {
  state = {
    beds: [],
    bedsLoading: false
  }

  handleClose() {
    this.props.closeModal()
  }

  handleChange(name, value) {
    this.props.updateField(name, value)
  }

  setDefaultStaffAppMetaData = () => sendStaffAppMetaData(this.props.tabDefaultMetaData)

  updateEducations(education) {
    const { organizationName, id } = this.props

    return this.props.fetch(`/organizations/${organizationName}/residents/${id}.json`, {
      method: "PATCH",
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        resident: {
          educations_attributes: [education]
        }
      })
    })
  }

  deleteEducation() {
    const { education, deleteEducation, closeModal, isStaffApp } = this.props

    this.setState({ loading: true })

    this.updateEducations({
      id: education.id,
      _destroy: true
    }).then(() => {
      this.setState({ loading: false })
      deleteEducation(education)
      if (isStaffApp) {
        alert("Education deleted successfully.")
        this.setDefaultStaffAppMetaData()
      }
      closeModal()
    })
  }

  saveEducation() {
    const { education, updateEducations, closeModal, isStaffApp } = this.props

    this.setState({ loading: true })

    this.updateEducations(education).then((data) => {
      this.setState({ loading: false })
      updateEducations(data.educations)
      if (isStaffApp) {
        alert("Education changes saved successfully.")
        this.setDefaultStaffAppMetaData()
      }
      closeModal()
    })
  }

  saveEducationFunction = (e) => {
    this.props.dispatch(this.saveEducation());
  }

  componentDidMount() {
    document.addEventListener('saveEducation', this.saveEducationFunction)
  }

  componentWillUnmount() {
    document.removeEventListener('saveEducation', this.saveEducationFunction)
  }

  render() {
    const {
      school_name,
      degree,
      start_date,
      graduate_date,
      move_in_gpa,
      move_out_gpa,

    } = this.props.education
    const { isStaffApp, hasDelete, hasEdit } = this.props
    const degreeOptions = buildOptions([
      "High School", "GED", "Associates", "Bachelors", "Masters", "Doctorate", "Other"
    ])
    const degreeValue = degreeOptions.find((option) => option.value === degree) || null
    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        {
          !isStaffApp &&
          <Modal.Header closeButton>
            <Modal.Title>Education</Modal.Title>
          </Modal.Header>
        }
        <Modal.Body className={hasEdit ? "" : "form-modal-width"}>
          {hasEdit ? (
            <>
              <Form.Group controlId="educationSchoolName">
                <Form.Label>School</Form.Label>
                <Form.Control
                  value={school_name}
                  onChange={(e) => {this.handleChange('school_name', e.target.value)}}
                />
              </Form.Group>
              <Form.Group controlId="educationDegree">
                <Form.Label>Degree</Form.Label>
                <Select
                  value={degreeValue}
                  options={degreeOptions}
                  isClearable={true}
                  onChange={(option) => {
                    this.handleChange(
                      'degree',
                      option ? option.value : ''
                    )
                  }} />
              </Form.Group>
              <Form.Group controlId="educationStartDate">
                <Form.Label>Start Date</Form.Label>
                <DatePicker
                  selected={start_date ? moment(start_date) : null}
                  className="form-control"
                  onChange={(date) => {
                    this.handleChange(
                      'start_date',
                      date ? date.format("YYYY-MM-DD") : null
                    )
                  }} />
              </Form.Group>
              <Form.Group controlId="educationGraduate">
                <Form.Label>Graduation Date</Form.Label>
                <DatePicker
                  selected={graduate_date ? moment(graduate_date) : null}
                  className="form-control"
                  onChange={(date) => {
                    this.handleChange(
                      'graduate_date',
                      date ? date.format("YYYY-MM-DD") : null
                    )
                  }} />
              </Form.Group>
              <Form.Group controlId="educationMoveInGPA">
                <Form.Label>GPA Upon Admit</Form.Label>
                <Form.Control
                  type="number"
                  value={move_in_gpa}
                  onChange={(e) => {this.handleChange('move_in_gpa', e.target.value)}}
                />
              </Form.Group>
              <Form.Group controlId="educationMoveOuGPA">
                <Form.Label>GPA Upon Discharge</Form.Label>
                <Form.Control
                  type="number"
                  value={move_out_gpa}
                  onChange={(e) => {this.handleChange('move_out_gpa', e.target.value)}}
                />
              </Form.Group>
            </>
          ) : (
            <>
              <Form.Group>
                <Form.Label>School</Form.Label>
                <div className="form-control-plaintext">{school_name || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Degree</Form.Label>
                <div className="form-control-plaintext">{degree || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Start Date</Form.Label>
                <div className="form-control-plaintext">{start_date ? moment(start_date).format('MM/DD/YYYY') : 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Graduation Date</Form.Label>
                <div className="form-control-plaintext">{graduate_date ? moment(graduate_date).format('MM/DD/YYYY') : 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>GPA Upon Admit</Form.Label>
                <div className="form-control-plaintext">{move_in_gpa || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>GPA Upon Discharge</Form.Label>
                <div className="form-control-plaintext">{move_out_gpa || 'N/A'}</div>
              </Form.Group>
            </>
          )}
        </Modal.Body>
        {
          !isStaffApp ? 
          <Modal.Footer>
            {
              this.props.action === "edit" && hasDelete &&
              <Button
                variant="outline-danger"
                onClick={() => {
                  const { education } = this.props
                  this.deleteEducation(education)
                }}>
                Delete
              </Button>
            }
            <Button
              variant="info"
              onClick={() => {
                this.saveEducation()
              }}>
              {this.props.action === "edit" ? "Update" : "Create"}
            </Button>
          </Modal.Footer> :
          <div className="p-4">
            {
              this.props.action === 'edit' &&  hasDelete &&
              <Button variant="outline-danger w-100" onClick={()=>this.deleteEducation(this.props.education)}>Delete</Button>
            }
          </div>
        }
      </Modal>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.educationModal.show,
    education: state.ui.educationModal.education,
    action: state.ui.educationModal.action,
    organizationName: state.organization.name,
    id: state.resident.id,
    isStaffApp: state.config.isStaffApp,
    resident: state.resident,
    resident_tabs: state.config.resident_tabs,
    config: state.config,
    tabDefaultMetaData: state.config.tab_default_meta_data.find(tab=> tab.detail == 'education_history'),
    hasDelete: state.current_user.permissions.includes('Delete'),
    hasEdit: state.current_user.permissions.includes('Edit')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch({ type: "CLOSE_EDUCATION_FORM_MODAL" }),
    updateEducations: (educations) => dispatch({ type: "UPDATE_EDUCATIONS", payload: { educations } }),
    createEducation: (education) => dispatch({ type: "CREATE_EDUCATION", payload: { education } }),
    deleteEducation: (education) => dispatch({ type: "DELETE_EDUCATION", payload: { education } }),
    updateField: (name, value) => dispatch({ type: "UPDATE_EDUCATION_FIELD", payload: { name, value } }),
    dispatch: (func) => dispatch(func())
  }
}

export default withFetchHook(connect(mapStateToProps, mapDispatchToProps)(EducationFormModal))
